import { render, staticRenderFns } from "./fccListaSolicitacoes.vue?vue&type=template&id=72cf1692"
import script from "./fccListaSolicitacoes.vue?vue&type=script&lang=js"
export * from "./fccListaSolicitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports